import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { getAssetSrc, customImageLoader } from '@restworld/utils-common';
import { Heading } from '@restworld/ui-ds-base';

function SubscriptionCancellationSuccessScreen() {
  const { t } = useTranslation('payment-and-invoices');

  return (
    <div>
      <Heading size={5} color="neutral" align="center">
        {t('you_have_successfully_canceled_the_slot_key')}
      </Heading>
      <div className="grid place-items-center mt-6">
        <Image
          src={getAssetSrc('/utils-assets/lead-user.svg')}
          alt=""
          width={340}
          height={340}
          loader={customImageLoader}
        />
      </div>
    </div>
  );
}

export default SubscriptionCancellationSuccessScreen;
